import { Outlet, createRootRoute } from '@tanstack/react-router';

import { tokenStore } from '../shared/api/token-store';
import { AppShell } from '../widgets/app-shell';
import { ScreenNotFound } from '../widgets/screen-error';

// An unknown address matches no `_shell` route, so the shell is put around it here.
export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () =>
    (tokenStore.access() ?? tokenStore.refresh()) ? (
      <AppShell>
        <ScreenNotFound />
      </AppShell>
    ) : (
      <ScreenNotFound />
    ),
});
